// extracted by mini-css-extract-plugin
export default {"container":"aq_u4p","mobile":"HcArW_"};